import { colors } from '@/theme/colors';
import type { HeaderCellConfig } from '@/ui/table/table.types';
import { ContentItemSortKey } from './feed.state';

export const contentItemsTableHeaders: HeaderCellConfig<ContentItemSortKey>[] =
  [
    {
      columnKey: 'title',
      sortKey: ContentItemSortKey.title,
      bgColor: colors.basics.white,
      width: '200px',
    },
    {
      columnKey: 'uploadedDate',
      sortKey: ContentItemSortKey.uploadedDate,
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'tags',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'category',
      sortKey: ContentItemSortKey.category,
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'isVisible',
      sortKey: ContentItemSortKey.isVisible,
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'action',
      hideLabel: true,
      bgColor: colors.basics.white,
    },
  ];
